import React, { useEffect, useRef, useState } from "react";
import { formatClassNames } from "../../helpers/util";
import Tooltip from "../Tooltip/Tooltip";

export default function InputWrapper({
  children,
  title,
  active,
  toolTip,
  className,
}) {
  const [titleOverflows, setTitleOverflows] = useState(null);

  const wrapperRef = useRef(null);
  const titleRef = useRef(null);
  useEffect(() => {
    if (wrapperRef.current != null && titleRef.current != null) {
      if ((titleRef.current.offsetWidth / wrapperRef.current.offsetWidth) > 0.5) {
        setTitleOverflows(<Tooltip icon="fas fa-info-circle" content={title} direction="left" />)
      }
    }
  }, [title]);

  return (
    <div className={formatClassNames("InputWrapper", className, { active })}>
      <div ref={wrapperRef}>
        {children}
        <span className="title" ref={titleRef}>
          {titleOverflows != null ? titleOverflows : title}
          {toolTip != null && (
            <Tooltip content={toolTip} icon="fas fa-question-circle" />
          )}
        </span>
      </div>
    </div>
  );
}
